import { apiClient } from '../../../../../lib/axios';
import type {
  ProfileComparisonParams,
  ProfileComparisonDemographicsResponse,
  ProfileComparisonHrvResponse,
  ProfileComparisonRecoveryResponse,
  ProfileComparisonStrainResponse,
  ProfileComparisonSleepResponse,
} from './types';

const buildQueryParams = (params: ProfileComparisonParams) => {
  const queryParams: Record<string, unknown> = {};

  if (params.start_date) queryParams.start_date = params.start_date;
  if (params.end_date) queryParams.end_date = params.end_date;
  if (params.departments.length > 0) {
    queryParams.departments = params.departments;
    queryParams.department = params.departments;
  }
  if (params.granularity) queryParams.granularity = params.granularity;
  if (params.region && params.region.length > 0) queryParams.region = params.region;
  if (params.depot && params.depot.length > 0) queryParams.depot = params.depot;
  if (params.age_range && params.age_range.length > 0) queryParams.age_range = params.age_range;
  if (params.sex) queryParams.sex = params.sex;
  if (params.shift_pattern && params.shift_pattern.length > 0) queryParams.shift_pattern = params.shift_pattern;
  if (params.client_id) queryParams.client_id = params.client_id;
  if (params.reliable_data) queryParams.reliable_data = true;

  return queryParams;
};

export const profileComparisonApi = {
  getDemographics: async (params: ProfileComparisonParams): Promise<ProfileComparisonDemographicsResponse> => {
    const response = await apiClient.get('/admin/metrics/profile-comparison/demographics', {
      params: buildQueryParams(params),
    });
    return response.data;
  },

  getHrv: async (params: ProfileComparisonParams): Promise<ProfileComparisonHrvResponse> => {
    const response = await apiClient.get('/admin/metrics/profile-comparison/hrv', {
      params: buildQueryParams(params),
    });
    return response.data;
  },

  getRecovery: async (params: ProfileComparisonParams): Promise<ProfileComparisonRecoveryResponse> => {
    const response = await apiClient.get('/admin/metrics/profile-comparison/recovery', {
      params: buildQueryParams(params),
    });
    return response.data;
  },

  getStrain: async (params: ProfileComparisonParams): Promise<ProfileComparisonStrainResponse> => {
    const response = await apiClient.get('/admin/metrics/profile-comparison/strain', {
      params: buildQueryParams(params),
    });
    return response.data;
  },

  getSleep: async (params: ProfileComparisonParams): Promise<ProfileComparisonSleepResponse> => {
    const response = await apiClient.get('/admin/metrics/profile-comparison/sleep', {
      params: buildQueryParams(params),
    });
    return response.data;
  },
};
